import React from 'react';
import { Link } from 'react-router-dom';

// Informativa privacy di base (GDPR). Adattare i dati del titolare prima del go-live.
function Privacy() {
  return (
    <div className="admin-page" style={{ maxWidth: 820 }}>
      <h1>Informativa sulla Privacy</h1>
      <p style={{ color: '#777' }}>Ultimo aggiornamento: 2026</p>

      <h2>Titolare del trattamento</h2>
      <p>
        Feste Da Piccoli. Per qualsiasi richiesta relativa ai tuoi dati puoi contattarci
        all'indirizzo email indicato nel sito.
      </p>

      <h2>Quali dati raccogliamo</h2>
      <ul>
        <li><strong>Fornitori:</strong> dati dell'account (tramite il nostro fornitore di autenticazione Clerk), dati dell'attività, contatti e contenuti delle schede.</li>
        <li><strong>Utenti che inviano richieste:</strong> nome, email, telefono (facoltativo) e il testo del messaggio inviato tramite il form di contatto.</li>
        <li>Dati tecnici di navigazione strettamente necessari al funzionamento (es. cookie di sessione per l'autenticazione).</li>
      </ul>

      <h2>Finalità e base giuridica</h2>
      <ul>
        <li>Erogare il servizio e mettere in contatto utenti e fornitori (esecuzione di un servizio richiesto).</li>
        <li>Gestire l'account e le schede dei fornitori (esecuzione del contratto).</li>
        <li>Adempiere a obblighi di legge.</li>
      </ul>

      <h2>Conservazione</h2>
      <p>I dati sono conservati per il tempo necessario alle finalità indicate e poi cancellati o anonimizzati.</p>

      <h2>Comunicazione a terzi</h2>
      <p>
        I dati possono essere trattati da fornitori che ci supportano nell'erogazione del servizio
        (es. autenticazione, hosting, invio email, archiviazione immagini), nel rispetto del GDPR.
        Quando invii una richiesta a un fornitore, i tuoi dati di contatto sono condivisi con quel fornitore
        per permettergli di risponderti.
      </p>

      <h2>I tuoi diritti</h2>
      <p>
        Hai diritto di accedere, rettificare, cancellare e limitare il trattamento dei tuoi dati,
        oltre al diritto di opposizione e portabilità. Puoi esercitarli contattandoci.
      </p>

      <h2>Cookie</h2>
      <p>
        Utilizziamo cookie tecnici necessari al funzionamento (incluso il login). Non utilizziamo
        cookie di profilazione senza il tuo consenso.
      </p>

      <p style={{ marginTop: '2rem' }}>
        <Link to="/" className="home-btn home-btn-light">Torna alla home</Link>
      </p>
    </div>
  );
}

export default Privacy;
